import React, { useState } from 'react'
import '../../assets/css/index.css'

import { useGetPaginatedMutation } from '../../store/api/endpoints/workshops'
import { useEffect } from 'react'
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';


const Workshops = () => {

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(15);

    const [
        getRegistros,
        {
            data: responseGetRegistros,
            error: errorGetRegistros,
            isLoading: isLoadingGetRegistros,
            isUninitialized: isUninitializedGetRegistros,
            isError: isErrorGetRegistros,
            isSuccess: isSuccessGetRegistros
        }
    ] = useGetPaginatedMutation()


    const onPageChange = (page) => {
        if (page >= 1 && responseGetRegistros.pagination?.totalPages && page <= responseGetRegistros.pagination.totalPages) {
            setPage(page)
        }
    }

    useEffect(() => {
        getRegistros({ page, limit })
    }, [page])

    if (isErrorGetRegistros) {
        return (
            <div align="center">
                <div style={{ width: '90%' }}>
                    <div style={{ marginTop: "50px" }}></div>
                    <div class="grid" style={{ width: '90%' }}>
                        <div class="col-12 md:col-12 lg:col-12">
                            {errorGetRegistros.status === 403 && <p>Para acceder aquí debes iniciar sesión.</p>}
                            {errorGetRegistros.status !== 403 && <p>Error al obtener los workshops.</p>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    if (isUninitializedGetRegistros || isLoadingGetRegistros) {
        return (
            <ProgressSpinner style={{ width: '100px', height: '100px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
        )
    }

    if (isSuccessGetRegistros) {
        return (
            <>
                <div align="center">
                    <div style={{ width: '90%' }}>
                        <div style={{ marginTop: "50px" }}></div>
                        <div class="grid" style={{ width: '90%' }}>
                            <div class="col-12 md:col-12 lg:col-12">
                                <p class="text-5xl lg:text-8xl md:text-7xl" style={{ fontWeight: "bold", color: "#b08372", fontSize: '120px', margin: 0 }}>WORKSHOPS</p>
                            </div>
                        </div>
                        <div style={{ height: 100 }}></div>
                        <div class="grid">
                            {
                                responseGetRegistros.data.map((item, index) => {
                                    return (
                                        <React.Fragment key={`unWorkshop-${index}`}>
                                            <div class="col-12 md:col-12 lg:col-12">
                                                <a href={`/workshops/${item._id}`} style={{ textDecoration: 'none', color: '#000000' }}>
                                                    <div class="grid">
                                                        <div class="col-12 md:col-1"></div>
                                                        <div class="col-12 md:col-3">
                                                            <img style={{ height: "auto", width: "100%", border: "4px solid #ae8686" }} src={item.previewImage} />
                                                        </div>
                                                        <div class="col-12 md:col-7">
                                                            <p class="text-3xl text-center md:text-left" style={{ fontWeight: "bold", margin: 5 }}>{item.title.toUpperCase()}</p>
                                                            <p class="text-2xl text-center md:text-left" style={{ margin: 5 }}><b><i className="pi pi-microphone"></i> Speaker:</b> {item.speaker}</p>
                                                            <p class="text-1xl text-justify" style={{ margin: 5 }}>{item.description}</p>
                                                        </div>
                                                        <div class="col-12 md:col-1"></div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div class="col-12">
                                                <div class="grid">
                                                    <div class="col-12 md:col-1 lg:col-1"></div>
                                                    <div class="col-12 md:col-10 lg:col-10">
                                                        <Divider type="solid" layout="horizontal" />
                                                    </div>
                                                    <div class="col-12 md:col-1 lg:col-1"></div>
                                                </div>
                                            </div>

                                        </React.Fragment>
                                    )
                                })
                            }
                        </div>
                        <div class="grid" style={{ width: '90%' }}>
                            <div class="col-12">
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center', // Alinea los ítems en el centro verticalmente
                                    gap: '10px', // Espacio entre el texto y el botón
                                    marginBottom: '20px'
                                }}>
                                    <Button
                                        onClick={() => onPageChange(responseGetRegistros.pagination.currentPage * 1 - 1)}
                                        disabled={responseGetRegistros.pagination.currentPage == 1}
                                        icon="pi pi-chevron-left"
                                        rounded
                                        text
                                        severity="secondary"
                                    />
                                    <span style={{ fontSize: '1.2rem', lineHeight: '1.5' }}>Mostrando página {responseGetRegistros.pagination.currentPage} de {responseGetRegistros.pagination.totalPages}.</span>
                                    <Button
                                        onClick={() => onPageChange(responseGetRegistros.pagination.currentPage * 1 + 1)}
                                        disabled={responseGetRegistros.pagination.currentPage == responseGetRegistros.pagination.totalPages}
                                        icon="pi pi-chevron-right"
                                        rounded
                                        text
                                        severity="secondary"
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    }
}

export default Workshops
